"use strict";

PF.Map = PF.Map || {};

PF.Map.PolygonList = class PolygonList extends PF.Entity.Array
{
    static get options()
    {
        return {
            searchable: true,
            search: '@{name}',
            searchLabel: 'Поиск',

            addable: false,
            editable: false,

            models: undefined,
            modelsConfig: { filterConfig: { rule: '' } },

            itemClass: PF.Map.PolygonList.Item,
            placemarkConfig: {}
        };
    }


    init()
    {
        if (this.models === undefined)
        {
            this.modelsConfig.list = this;
            this.models = new PF.Models(this.modelsConfig);
        }
        else
        {
            this.models.list = this;
            PF.Options.assignOptions(this.models, this.modelsConfig);
        }

        this.models.on('addOne', this.addOneSlot.bind(this));
        this.models.on('remove', this.removeSlot.bind(this));

        this.recreate(this.models);

    }

    recreate(array)
    {
        for (let i = 0; i < array.length; i++)
        {
            // let item = this.create(array[i]);
            this.addOneSlot(array[i]);
            // this.splice(i, 0, item);
        }
    }

    addOneSlot(model)
    {
        let index = this.models.indexOf(model);

        let item = model.options.listItem;
        if (item === undefined)
        {
            item = this.create(model, index);
        }

        this.splice(index, 0, item);
        item.render();
        if (model.options.isNewRecord === true)
        {
            this.trigger('add-success', model, item);
        }
    }

    create(model, index)
    {
        return PF.H.create(
            this.itemClass,
            {
                list: this,
                model: model,
                map: this.map,
                polygonProperties: this.polygonProperties,
                polygonOptions: this.polygonOptions,
                index: index
            }, model);
    }

    removeSlot(removed)
    {
        let idIndex = this.models.idIndex;
        for (let i = 0; i < removed.length; i++)
        {
            let index = undefined;
            for (let j = 0; j < this.length; j++)
            {
                if (this[j][idIndex] === removed[i][idIndex])
                {
                    index = j;
                    break;
                }
            }
            if (index !== undefined)
            {
                this[index].destroy();
                this.splice(index, 1);
            }
        }
    }

    update(limit = this.length)
    {
        this.models.update(limit);
    }

    destroy()
    {
        this.map.geoObjects.remove(this.mapPolygon);
        super.destroy();

    }
};


PF.Map.PolygonList.Item = class Item extends PF.Entity
{
    static get options()
    {
        return {
            map: undefined,
            list: undefined,
            index: undefined,
            model: undefined,
            polygonProperties: {
                hintContent: "Многоугольник"
            },
            polygonOptions: {
                fillColor: '#00FF0088',
                strokeWidth: 5
            }
        };
    }

    init()
    {
    }

    get renderer()
    {
        return ``;
    }

    render()
    {
        this.onRender();
    }
    onRender()
    {
        this.marker = new ymaps.Polygon(this.model.cords, this.polygonProperties, this.polygonOptions);


        this.map.geoObjects.add(this.marker);
    }

    destroy()
    {
        this.map.geoObjects.remove(this.marker);
    }

};


